import { OutdatedDevicesAlertEnabledComponent } from '../../../../models/constants/constants';
import { IAppState } from '../../../../models/reduxState';

export const getDevices = (state: IAppState, callingComponent: OutdatedDevicesAlertEnabledComponent) => {
    return callingComponent === OutdatedDevicesAlertEnabledComponent.ModalitySection
    ? state.ContactState.ModalitySectionState.modalityResponse?.OutdatedWindowsDevices
    : state.ContactState.SelfHelpAlchemyState.alchemyResults?.OutdatedWindowsDevices;
  };

  export const getIsAlertDismissed = (state: IAppState, callingComponent: OutdatedDevicesAlertEnabledComponent) => {
    return callingComponent === OutdatedDevicesAlertEnabledComponent.ModalitySection
      ? state.ContactState.ModalitySectionState.isOutdatedDevicesAlertDismissed
      : state.ContactState.SelfHelpAlchemyState.isOutdatedDevicesAlertDismissed;
  };

  export const getShouldExpandAlert = (state: IAppState, callingComponent: OutdatedDevicesAlertEnabledComponent) => {
    return callingComponent === OutdatedDevicesAlertEnabledComponent.ModalitySection
      ? state.ContactState.ModalitySectionState.shouldExpandOutdatedDevicesAlert
      : state.ContactState.SelfHelpAlchemyState.shouldExpandOutdatedDevicesAlert;
  };

  export const showAlertSelector = (state: IAppState, callingComponent: OutdatedDevicesAlertEnabledComponent) => {
    const isAlertEnabled = state.ContactState.SharedState.shouldShowOutdatedDevicesAlert;
    const isAlertDismissed = getIsAlertDismissed(state, callingComponent);
    const devices = getDevices(state, callingComponent);
    return isAlertEnabled && !isAlertDismissed && !!devices && devices.length > 0;
  };
